import { useItemSet, PublishValidationErrorCode } from '@exam-management/common/item-set-provider';
import { Link, useParams } from '@exam-management/router';
import { Alert, AlertTitle, Flex, Text, ListItem, List, styled } from '@shared/components';
import { createSearchParams } from 'react-router-dom';

const StyledLink = styled(Link)({
  color: 'inherit',
});

export default function ItemSetPublishErrorsAlert() {
  const { structureId } = useParams('/qbank-structures/:structureId');
  const { itemSet, publicationErrors } = useItemSet();
  const { id, questions: subQuestions } = itemSet;

  if (publicationErrors?.length === 0) return null;

  const isSubQuestionEmpty = publicationErrors.find(
    (error) =>
      error.field === 'questions' && error.code === PublishValidationErrorCode.NOT_ENOUGH_QUESTIONS,
  );

  const invalidSubQuestions = publicationErrors
    .filter(
      (error) => error.field === 'questions' && error.code === PublishValidationErrorCode.MALFORMED,
    )
    .map((error) => {
      return subQuestions?.find((subQuestion) => subQuestion.id == error.value);
    })
    .filter((subQuestion) => !!subQuestion)
    .sort((a, b) => Number(a.groupOrder) - Number(b.groupOrder));

  const hasInvalidSubQuestions = invalidSubQuestions.length > 0;

  return (
    <Alert
      severity='error'
      sx={(theme) => ({
        alignItems: 'flex-start',
        m: theme.spacing(6),
        mb: theme.spacing(0),
        '& .MuiAlert-message': { pl: theme.spacing(1) },
        ...theme.typography.body2,
      })}
    >
      <AlertTitle variant='body1Semibold'>ไม่สามารถ Publish คำถามได้</AlertTitle>
      <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(3), height: '100%' }}>
        {isSubQuestionEmpty ? (
          <Text variant='body2'>กรุณาเพิ่ม Sub-Question อย่างน้อย 2 ข้อ</Text>
        ) : null}
        {hasInvalidSubQuestions ? (
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(3) }}>
            <Text variant='body2'>กรุณากรอกข้อมูลใน Sub-Question ต่อไปนี้ให้ครบถ้วน</Text>
            <List
              sx={(theme) => ({
                listStyle: 'disc',
                pl: theme.spacing(4),
                py: theme.spacing(0),
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(2),
                height: '100%',
                flex: 1,
              })}
            >
              {invalidSubQuestions?.map(({ id: subQuestionId, groupOrder }, index) => (
                <ListItem sx={{ display: 'list-item', p: (theme) => theme.spacing(0) }} key={index}>
                  <Text variant='body2'>
                    <Text variant='inherit' component='span'>
                      ข้อที่ {groupOrder ?? 1}
                    </Text>
                    <StyledLink
                      to={{
                        pathname:
                          '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId',
                        search: createSearchParams({
                          validate: 'publish',
                        }).toString(),
                      }}
                      params={{ structureId, questionId: id, subQuestionId }}
                      target='_blank'
                      rel='noopener noreferrer'
                      sx={{ ml: (theme) => theme.spacing(4) }}
                    >
                      ไปที่คำถาม
                    </StyledLink>
                  </Text>
                </ListItem>
              ))}
            </List>
          </Flex>
        ) : null}
      </Flex>
    </Alert>
  );
}
